import React from 'react';
import { useTheme } from '../context/ThemeContext';
// Import from public folder instead
const darkLogo = '/images/cliveAi-logo-white-transparent.png';
const lightLogo = '/images/cliveAi-logo-black.png';

export default function Logo({ size = 'default' }) {
  const { darkMode } = useTheme();
  
  const sizeClasses = {
    small: 'h-6',
    default: 'h-8',
    large: 'h-12'
  };

  return (
    <img
      src={darkMode ? darkLogo : lightLogo}
      alt="CliveAI"
      className={`${sizeClasses[size]} w-auto`}
    />
  );
} 